export const COLORS = {
  //TODO: Gotta finalize these colors...
  success: 'green',
  dark_green: '#00a854',
  error: 'red',
  warning: '#ffbf00',
  dark_yellow: '#ffbf00',
  primary: 'blue',
  dark_blue: '#108EE9',
  cyan: '#3db8c1',
  black: '#000',
  active: 'green',
  inactive: 'red'
};
